/* @ngInject */

export default (dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanApplicationBackChannelHistory(
    id,
    idWorkflow,
    idOwner,
    idStage,
    applicationId,
    lenderAssignedId,
    status,
    timeStamp
  ) {
    this.id = id;
    this.idWorkflow = idWorkflow;
    this.idOwner = idOwner;
    this.idStage = idStage;
    this.applicationId = applicationId;
    this.lenderAssignedId = lenderAssignedId;
    this.status = status;
    this.timeStamp = timeStamp;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanApplicationBackChannelHistory.Blank = function () {
    return HomeLoanApplicationBackChannelHistory.Build({
      id: _.uuid(),
      idWorkflow: '',
      idOwner: '',
      idStage: '',
      applicationId: '',
      lenderAssignedId: '',
      status: '',
      timeStamp: dateTimeService.epoch()
    });
  };
  HomeLoanApplicationBackChannelHistory.Build = function (data) {
    return new HomeLoanApplicationBackChannelHistory(
      data.id ? data.id : _.uuid(),
      data.idWorkflow ? data.idWorkflow : '',
      data.idOwner ? data.idOwner : '',
      data.idStage ? data.idStage : '',
      data.applicationId ? data.applicationId : '',
      data.lenderAssignedId ? data.lenderAssignedId : '',
      data.status ? data.status : '',
      data.timeStamp ? data.timeStamp : dateTimeService.epoch()
    );
  };

  return HomeLoanApplicationBackChannelHistory;
};
